import TYPES from '@/modules/shared/types';

// Domain
import {
  ProductRepository,
} from '../../domain/repositories/product-repository';
import {
  ProductEntity,
} from '../../domain/entities/product-entity';
import { HttpConnector } from '@/modules/shared/domain/connectors/http';
import Inject from '@/modules/shared/domain/dependency_injection/inject';
import Injectable from '@/modules/shared/domain/di/injectable';

@Injectable()
export default class ProductHttpRepository implements ProductRepository {
  @Inject(TYPES.HTTP_CONNECTOR)
  private readonly http_connector!: HttpConnector;

  private readonly endpoint = `${process.env.VUE_APP_API_URL}/api/v1/app/catalogs/products/`;

  get(): Promise<Array<ProductEntity>> {
    return new Promise((resolve, reject) => {
      this.http_connector.execute(`${this.endpoint}filtered-by-ids/`)
        .then((response) => response.json())
        .then(({ success, message, data }) => {
          if (success) {
            resolve(data);
          } else {
            reject(new Error(message));
          }
        })
        .catch(reject);
    });
  }
}
